/**
 * Customer-service SKU reveal shortcut.
 *
 * SKUs are hidden on product pages by default. Pressing Alt+Shift+U toggles a
 * session-persisted flag that reveals the SKU block on every product for the
 * rest of the browser session, so CS reps don't have to open the admin to
 * look up a variant SKU while on a call.
 */

export const SKU_VISIBILITY_STORAGE_KEY = 'cariloha:sku-visible';
export const SKU_VISIBILITY_TOGGLE_EVENT = 'cariloha:sku-toggle';

export function isSkuVisible() {
  return sessionStorage.getItem(SKU_VISIBILITY_STORAGE_KEY) === '1';
}

document.addEventListener('keydown', (event) => {
  if (!event.altKey || !event.shiftKey || event.code !== 'KeyU') return;

  if (isSkuVisible()) {
    sessionStorage.removeItem(SKU_VISIBILITY_STORAGE_KEY);
  } else {
    sessionStorage.setItem(SKU_VISIBILITY_STORAGE_KEY, '1');
  }

  window.dispatchEvent(new CustomEvent(SKU_VISIBILITY_TOGGLE_EVENT));
});
